import { createGlobalStyle } from 'styled-components'

const LockBodyScroll = createGlobalStyle`
  html, body {
    overflow: hidden;
  }
`

export default LockBodyScroll
